<template>
  <div>
    <hr :style="'border-top:'+currentField.maxheight+'px '+currentField.dividerType+' '+ currentField.color+';width:'+currentField.maxwidth+'%;'">
    <div class="html2pdf__page-break"></div>
  </div>

</template>

<script>
export default {
  name: 'Divider',
  props: ['currentField'],
  data() {
    return {
      // input: ''
    };
  },
//   computed: {
//     attributesBinding() {
//       var attr = {};
//       if (this.currentField.showWordLimit) {
//         attr.maxlength = this.currentField.maxlength;
//         attr['show-word-limit'] = this.currentField.showWordLimit;
//       }

//       if (this.currentField.clearable) {
//         attr.clearable = this.currentField.clearable;
//       }

//       if (this.currentField.disabled) {
//         attr.disabled = this.currentField.disabled;
//       }

//       if (this.currentField.showPassword) {
//         attr['show-password'] = this.currentField.showPassword;
//       }

//       if (this.currentField.isPlaceholderVisible) {
//         attr.placeholder = this.currentField.placeholder;
//       }
//       // attr.componentValue = this.input;
//       return attr;
//     }
//   },
//   methods: {
//     textBoxChange(value) {
//       this.currentField.componentValue = value;
//     }
//   }
};
</script>
